var $$ = $$ || {};

$$.Cart = class Cart {
	constructor (root, options = {}) {
		var defaultOptions = {
			url: '/' // todo action url
		};

		this.root = root;
		this.options = _.assign(defaultOptions, options);

		this.state = 0;

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_cacheNodes () {
		this.nodes = {
			cardsContainer: this.root.find('.cards'),
			cards: this.root.find('.js-card'),

			code: this.root.find('.js-code'),
			submitButton: this.root.find('.js-submit'),

			summary: this.root.find('.b-summary'),
			finish: this.root.find('.b-cart-finish'),

			codeContaiter: this.root.find('.js-input-code'),
			invalidMessage: this.root.find('.js-invalid'),
			discountMessage: this.root.find('.js-discount'),
			closeInvalidButton: this.root.find('.js-close-invelid'),

			cleanButton: this.root.find('.js-clean'),
			offerButton: this.root.find('.js-offer')
		};
	}

	_bindEvents () {
		this.nodes.submitButton.on('click', () => {
			var data = {
				action: "code",
				code: this.nodes.code.val()
			};

			$.ajax({
				url: $$.Config.addCoupon,
				method: 'POST',
				data: data,
				success: (response) => {
					response = $.parseJSON(response);
					if (response.APPLY_COUPON === 'N') {
						this.nodes.invalidMessage.show();
						this.nodes.discountMessage.hide();
						this.nodes.codeContaiter.hide();
					} else {
						this.nodes.invalidMessage.hide();
						this.nodes.discountMessage.show();
						this.nodes.discountMessage.find('.price').text(response.COUPON_DISCOUNT);
						$('.js-sum-all').text(response.SUM_ALL);
						this.nodes.codeContaiter.hide();
					}

				}
			});
		});

		this.nodes.cleanButton.on('click', () => {
			var data = {
				action: "clean"
			};

			$.ajax({
				url: $$.Config.removeAllCartUrl,
				method: 'POST',
				data: data,
				success: (response) => {
					response = $.parseJSON(response);

					if (response.success) {
						$$.Noty['successMessage'](response.success);

						$('.js-sum-all').text(response.SUM);
						$('.js-count-all').text(response.amount);
						$('.js-count-text-all').text(response.text_amount);

						if (!response.amount) {
							this._clearCart();
						}
					} else {
						$$.Noty['errorMessage'](response.error);
					}
				}
			});
		});

		this.nodes.offerButton.on('click', () => {
			var data = {
				action: "offer"
			};

			$.ajax({
				url: this.options.url,
				method: 'GET',
				data: data,
				success: (response) => {
					// todo: proceed response
				}
			});
		});

		this.nodes.closeInvalidButton.on('click', () => {
			this.nodes.invalidMessage.hide();
			this.nodes.discountMessage.hide();

			this.nodes.codeContaiter.show();
		});

		this.nodes.cards.on('click', '.js-remove', (event) => {
			var card = $(event.target).closest('.js-card');

			var data = {
				action: "delete",
				id: card.data('id')
			};

			$.ajax({
				url: $$.Config.removeCartUrl,
				method: 'POST',
				data: data,
				success: (response) => {
					response = $.parseJSON(response);

					if (response.success) {
						$$.Noty['successMessage'](response.success);
						card.remove();

						$('.js-sum-all').text(response.SUM);
						$('.js-count-all').text(response.amount);
						$('.js-count-text-all').text(response.text_amount);

						if (!response.amount) {
							this._clearCart();
						}
					} else {
						$$.Noty['errorMessage'](response.error);
					}
				}
			});
		});

		this.nodes.cards.on('click', '.SALE_DELAY_ELEM', (event) => {
			var delayLink = $(event.currentTarget);
			var card = delayLink.closest('.js-card');

			event.preventDefault();

			$.ajax({
				url: delayLink.attr('href'),
				method: 'GET',
				success: (response) => {
					response = $.parseJSON(response);

					if (response.success) {
						$$.Noty['successMessage'](response.success);
						card.remove();

						$('.js-sum-all').text(response.SUM);
						$('.js-count-all').text(response.amount);
						$('.js-count-text-all').text(response.text_amount);

						if (!response.amount) {
							this._clearCart();
						}
					} else {
						$$.Noty['errorMessage'](response.error);
					}
				}
			});
		});
	}

	_ready () {
		this.nodes.invalidMessage.hide();
		this.nodes.discountMessage.hide();

		this.nodes.codeContaiter.show();
	}

	_clearCart () {
		this.nodes.cards.remove();
		this.nodes.summary.remove();
		this.nodes.finish.remove();
		this.nodes.cardsContainer.append('<p><font class="errortext">Ваша корзина пуста</font></p>');

		var cartSmall = $('.js-cart-small');

		cartSmall.find('.empty-cart').removeClass('hidden');
		cartSmall.find('.money').addClass('hidden');
	}
};

Number.isInteger = Number.isInteger || function (value) {
		return typeof value === "number" &&
			isFinite(value) &&
			Math.floor(value) === value;
	};
